export default __webpack_public_path__ + "static/media/chat_bot_image6.8dcc75d8.jpg";